import { tutorialTooltipImgs } from "../../../assets";
import CheckIcon from "@mui/icons-material/Check";

const GlossaryTooltipContent = () => (
  <div className="glossary-tutorial-tooltip-content">
    <div>
      {["Definitions", "Examples", "Tips"].map((text, i) => (
        <GlossaryContentListItem text={text} key={i} />
      ))}
    </div>
    <img
      src={tutorialTooltipImgs.glossaryTooltipContentImg}
      alt="Glossary Items"
    />
  </div>
);

export default GlossaryTooltipContent;

function GlossaryContentListItem({ text }) {
  return (
    <div>
      <CheckIcon color="inherit" fontSize="inherit" />
      <span>{text}</span>
    </div>
  );
}
